import { Clock } from 'lucide-react';

interface ItineraryStep {
  heure: string;
  titre: string;
  description: string;
}

interface ExcursionItineraryProps {
  itineraire: ItineraryStep[];
}

export const ExcursionItinerary = ({ itineraire }: ExcursionItineraryProps) => {
  if (!itineraire || itineraire.length === 0) return null;

  return (
    <section>
      <div className="w-10 h-1 bg-roca-red mb-4" />
      <h2 className="text-3xl font-playfair font-bold mb-6">Itinéraire détaillé</h2>
      <div className="relative">
        {/* Timeline line */}
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />
        
        <div className="space-y-8">
          {itineraire.map((step, index) => (
            <div key={index} className="relative pl-16">
              {/* Timeline dot */}
              <div className="absolute left-0 top-1 w-12 h-12 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-bold">
                <Clock className="w-5 h-5" />
              </div>
              
              <div className="bg-card border rounded-lg p-6 shadow-card hover:shadow-float transition-shadow">
                <div className="flex items-baseline gap-3 mb-2">
                  <span className="text-sm font-poppins font-semibold text-primary">{step.heure}</span>
                  <h3 className="text-xl font-poppins font-bold">{step.titre}</h3>
                </div>
                <p className="text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
